module.exports = __webpack_public_path__ + "img/bum(3).a0b8affb.png";